import React from 'react';

const FullScreenLoader = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        background: '#0004',
        zIndex: 5000,
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          padding: '50px',
          background: '#fff',
          zIndex: 5001,
          borderRadius: 900,
          filter: 'drop-shadow(0 0 10px #8888)',
        }}
      >
        <div className="animation-push-pop animation-loader">
          <div />
          <div />
        </div>
      </div>
    </div>
  );
};

export default FullScreenLoader;
